import React, { FC, useEffect, useRef, useState } from 'react';

import { RosterCardLayout } from './roster-card-layout';

import { MouseBasedParallax } from '@wwe-portal/ui/effects/mouse-based-parallax/mouse-based-parallax';
import { SuperstarShining } from '@wwe-portal/ui/effects/shining/superstar-shining';

const CardContent: FC<{
  image: string;
  maskImage?: string;
  lightType: 'white' | 'rainbow';
  name: string;
  effectEnabled: boolean;
}> = ({ image, lightType, name, maskImage, effectEnabled }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [spotlightInsetX, setSpotlightInsetX] = useState(0);
  useEffect(() => {
    const resizeHandler = () => {
      if (!containerRef.current) return;
      const { width, height } = containerRef.current.getBoundingClientRect();
      setSpotlightInsetX((width - (height * 390) / 512) / 2);
    };

    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);
  return (
    <MouseBasedParallax enabled={effectEnabled} containerRef={containerRef}>
      <SuperstarShining
        imageUrl={image}
        lightType={lightType}
        enabled={effectEnabled}
        shiningProps={{
          style: {
            left: spotlightInsetX,
            right: spotlightInsetX,
          },
        }}
        maskImage={maskImage}
        imageProps={{
          alt: name,
          fill: true,
          className: 'absolute inset-0 object-contain',
          unoptimized: false,
        }}
      />
    </MouseBasedParallax>
  );
};

interface RosterCardFrontDetailProps {
  image: string;
  maskImage?: string;
  name: string;
  lightType: 'white' | 'rainbow';
  flipButton?: React.ReactNode;
  effectEnabled: boolean;
}

export const RosterCardFrontDetail: FC<RosterCardFrontDetailProps> = ({
  flipButton,
  image,
  maskImage,
  lightType,
  name,
  effectEnabled,
}) => {
  return (
    <RosterCardLayout
      className="h-full"
      image={
        <CardContent
          image={image}
          lightType={lightType}
          name={name}
          maskImage={maskImage}
          effectEnabled={effectEnabled}
        />
      }
      flipButton={flipButton}
    />
  );
};
